var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BatchImport"},[_c('a-upload',{attrs:{"customRequest":_vm.uploadFiles,"accept":".xls, .xlsx","showUploadList":false}},[_c('a-button',[_vm._v("批量导入")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }